<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading" :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">垃圾桶设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="垃圾桶编号" prop="TRASHCODE">
                <el-input
                  v-model="data.TRASHCODE"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="垃圾桶名称" prop="TRASHNAME">
                <el-input
                  v-model="data.TRASHNAME"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="垃圾桶类型" prop="TRASHTYPE">
                <el-select v-model="data.TRASHTYPE" placeholder="请选择" :disabled="!IsEdit" style="width: 100%;">
                  <el-option
                    v-for="item in trashTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="当前使用情况" prop="CURRENTUSAGE">
                <el-input
                  v-model="data.CURRENTUSAGE"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="总容量" prop="TOTALCAPACITY">
                <el-input
                  v-model="data.TOTALCAPACITY"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="IP地址" prop="TRASHIP">
                <el-input
                  v-model="data.TRASHIP"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="区域" prop="BELONGAREA">
                <el-select
                  v-model="data.BELONGAREA"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in EqRegionArr"
                    :key="item.RegionId"
                    :label="item.RegionName"
                    :value="item.RegionId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="LONGITUDE">
                <el-input
                  v-model="data.LONGITUDE"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="LATITUDE">
                <el-input
                  v-model="data.LATITUDE"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.LATITUDE"
              :point_lng="data.LONGITUDE"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="负责人" prop="CHARGEPERSON">
                <el-input
                  v-model="data.CHARGEPERSON"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人电话" prop="CHARGEPERSONTEL">
                <el-input
                  v-model="data.CHARGEPERSONTEL"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="厂家" prop="MANUFACTOR">
                <el-input
                  v-model="data.MANUFACTOR"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保修期" prop="PERIODDEFECTS">
                <el-input
                  v-model="data.PERIODDEFECTS"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "SmartTrashManagerInfo",
  controller: "UI",
  action: "SmartTrashManagerInfo",
  data() {
    return {
      data: {
        LATITUDE: "",
        LONGITUDE: "",
      },
      trashTypeOptions: [
        { value: 1, label: "湿垃圾" },
        { value: 2, label: "干垃圾" },
        { value: 3, label: "有害垃圾" },
        { value: 4, label: "可回收物" },
      ],
      loading: false,
      loadingText: '加载中...',
      EqRegionArr: [],
      IsEdit: false,
      rules: {
        TRASHCODE: [
          { required: true, message: "请输入垃圾桶编号", trigger: "blur" },
        ],
        TRASHNAME: [
          { required: true, message: "请输入垃圾桶名称", trigger: "blur" },
        ],
        LONGITUDE: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        LATITUDE: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        BELONGAREA: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        TRASHTYPE: [
          { required: true, message: "请选择垃圾桶类型", trigger: "change" },
        ]
      },
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    //区域
    this.getRegionInfo();
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onGotLngLat(obj) {
      this.data.LATITUDE = obj.lat || 0;
      this.data.LONGITUDE = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        new MyApis.TranResourcesApi()
          .GetItemById({ID:InfoId})
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      this.loading = true;
      this.loadingText = "保存中..."
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Id: uuid,
          TRASHSTATUS: 0, //1 在线 0 离线
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
